<app-dialog [title]="'New Transaction'" [show]="show" [size]="'lg'" [position]="'right'" (close)="onClose()"
  [showHeader]="showHeader">
  <app-spinner [isLoading]="isLoading" *ngIf="isLoading"
    style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 40; display: flex; align-items: center; justify-content: center;"></app-spinner>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col h-[100%] min-h-[400px]">
    <!-- Scrollable Content -->
    <div
      class="flex-1 overflow-y-auto space-y-2 sm:space-y-2 md:space-y-2 lg:space-y-2 xl:space-y-2 2xl:space-y-2 px-2 sm:px-4 md:px-6 pb-2">
      <!-- Agency Field - Only show for non-approved attorneys -->
      <div *ngIf="!isApprovedAttorney">
        <label
          class="block text-xs sm:text-sm md:text-base lg:text-lg xl:text-base 2xl:text-lg font-medium text-gray-700">Agency*</label>
        <div class="relative">
          <select id="create-transaction-agency-field"
            class="w-full border border-gray-300 rounded-lg px-2 py-2 pr-10 text-base shadow-sm focus:outline-none appearance-none bg-white cursor-pointer"
            formControlName="agencyId" (change)="onAgencySelect($event)" required>
            <!-- Placeholder option -->
            <option value="null" disabled selected>Select an agency</option>

            <!-- Grouped options -->
            <ng-container *ngFor="let group of groupedAgencies">
              <optgroup [label]="group.agencyLegalName">
                <option *ngFor="let agency of group.agencies" [value]="agency.issuingAgentId">
                  {{ agency.accountNumber }} / {{ agency.locationName }} ({{ agency.status }})
                </option>
              </optgroup>
            </ng-container>
          </select>

          <!-- Arrow icon (Tailwind only) -->
          <div class="pointer-events-none absolute inset-y-0 right-2 flex items-center">
            <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        <div *ngIf="form.get('agencyId')?.touched && form.get('agencyId')?.invalid" class="text-xs text-red-500 mt-2">
          Agency is required.
        </div>
      </div>

      <!-- File Number -->
      <div>
        <label
          class="block text-xs sm:text-sm md:text-base lg:text-lg xl:text-base 2xl:text-lg font-medium text-gray-700">File
          Number*</label>
        <input id="create-transaction-file-number-field" type="text" formControlName="fileNumber" placeholder="Enter File Number" maxlength="50"
          class="w-full border border-gray-300 rounded-lg px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base lg:text-lg xl:text-lg 2xl:text-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 h-8 sm:h-6 md:h-7 lg:h-8 xl:h-8 2xl:h-10
    placeholder:text-[#ADAEBC] placeholder:font-normal placeholder:text-base placeholder:leading-6 placeholder:font-[Inter]" />
        <div *ngIf="form.get('fileNumber')?.touched && form.get('fileNumber')?.invalid"
          class="text-xs text-red-500 mt-1">
          File Number is required.
        </div>
      </div>

      <!-- Name Fields -->
      <div>
        <label
          class="block text-xs sm:text-sm md:text-base lg:text-lg xl:text-base 2xl:text-lg font-medium text-gray-700">First
          Name*</label>
        <input id="create-transaction-first-name-field" type="text" formControlName="firstName" placeholder="Enter First Name" maxlength="100"
          class="w-full border border-gray-300 rounded-lg px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base lg:text-lg xl:text-lg 2xl:text-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 h-8 sm:h-6 md:h-7 lg:h-8 xl:h-8 2xl:h-10
          placeholder:text-[#ADAEBC] placeholder:font-normal placeholder:text-base placeholder:leading-6 placeholder:font-[Inter]" />
        <div *ngIf="form.get('firstName')?.touched && form.get('firstName')?.invalid" class="text-xs text-red-500 mt-1">
          First Name is required.
        </div>
      </div>
      <div>
        <label
          class="block text-xs sm:text-sm md:text-base lg:text-lg xl:text-base 2xl:text-lg font-medium text-gray-700">Middle
          Name</label>
        <input id="create-transaction-middle-name-field" type="text" formControlName="middleName" placeholder="Enter Middle Name" maxlength="100"
          class="w-full border border-gray-300 rounded-lg px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base lg:text-lg xl:text-lg 2xl:text-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 h-8 sm:h-6 md:h-7 lg:h-8 xl:h-8 2xl:h-10
          placeholder:text-[#ADAEBC] placeholder:font-normal placeholder:text-base placeholder:leading-6 placeholder:font-[Inter]" />
      </div>
      <div>
        <label
          class="block text-xs sm:text-sm md:text-base lg:text-lg xl:text-base 2xl:text-lg font-medium text-gray-700">Last
          Name*</label>
        <input id="create-transaction-last-name-field" type="text" formControlName="lastName" placeholder="Enter Last Name" maxlength="100"
          class="w-full border border-gray-300 rounded-lg px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base lg:text-lg xl:text-lg 2xl:text-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 h-8 sm:h-6 md:h-7 lg:h-8 xl:h-8 2xl:h-10
          placeholder:text-[#ADAEBC] placeholder:font-normal placeholder:text-base placeholder:leading-6 placeholder:font-[Inter]" />
        <div *ngIf="form.get('lastName')?.touched && form.get('lastName')?.invalid" class="text-xs text-red-500 mt-1">
          Last Name is required.
        </div>
      </div>

      <!-- Email -->
      <div>
        <label
          class="block text-xs sm:text-sm md:text-base lg:text-lg xl:text-base 2xl:text-lg font-medium text-gray-700">Email
          Address*</label>
        <input id="create-transaction-email-field" type="email" formControlName="email" maxlength="100" [ngClass]="{
            'border-red-500': form.get('email')?.touched && form.get('email')?.invalid
          }" placeholder="Enter Address"
          class="w-full border border-gray-300 rounded-lg px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base lg:text-lg xl:text-lg 2xl:text-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 h-8 sm:h-6 md:h-7 lg:h-8 xl:h-8 2xl:h-10
          placeholder:text-[#ADAEBC] placeholder:font-normal placeholder:text-base placeholder:leading-6 placeholder:font-[Inter]" />
        <div *ngIf="form.get('email')?.touched && form.get('email')?.invalid" class="text-xs text-red-500 mt-1">
          <span *ngIf="form.get('email')?.errors?.['required']">Email is required.</span>
          <span *ngIf="form.get('email')?.errors?.['email']">Please enter a valid email address.</span>
        </div>
      </div>

      <div>
        <label
          class="block text-xs sm:text-sm md:text-base lg:text-lg xl:text-base 2xl:text-lg font-medium text-gray-700">Phone
          Number</label>
        <div class="relative flex items-center space-x-2">
          <div class="w-[40%] border border-gray-300 rounded-lg px-1 sm:px-2 md:px-2 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base lg:text-lg xl:text-lg 2xl:text-lg shadow-sm h-8 sm:h-6 md:h-7 lg:h-8 xl:h-8 2xl:h-10 bg-gray-50 flex items-center justify-center text-gray-600 font-medium cursor-default">
            (US/CA)+1
          </div>
          <input id="create-transaction-phone-field" #phoneInput type="tel" formControlName="phone" (input)="onPhoneInput($event)" maxlength="15"            (blur)="onPhoneBlur()" (focus)="onPhoneFocus()" (mouseenter)="onPhoneMouseEnter()"
            (mouseleave)="onPhoneMouseLeave()" placeholder="(___) ___-____"
            class="w-full border border-gray-300 rounded-lg px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base lg:text-lg xl:text-lg 2xl:text-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 h-8 sm:h-6 md:h-7 lg:h-8 xl:h-8 2xl:h-10" />          <div *ngIf="phoneTooltipVisible"
            class="absolute left-0 mt-1 flex items-center text-xs text-white bg-gray-900 rounded-lg px-4 py-2 z-20 shadow-lg min-w-[260px]"
            style="top: 100%">
            <div class="absolute left-8 -top-2 w-3 h-3 flex items-center justify-center">
              <svg class="w-3 h-3 text-gray-900" viewBox="0 0 12 12" fill="currentColor">
                <polygon points="6,0 12,12 0,12" />
              </svg>
            </div>
            <span class="flex items-center">
              <span class="flex items-center justify-center w-5 h-5 mr-2">
                <i class="pi pi-info-circle text-white text-base"></i>
              </span>
              Let the recipient know they'll receive a text shortly.
            </span>
          </div>
        </div>
        <div *ngIf="phoneTouched && phoneInvalid" class="text-xs text-red-500 mt-1">
          {{ phoneErrorMessage }}
        </div>
      </div>
    </div>
    <div dialog-actions class="flex justify-end gap-2 px-2 sm:px-4 md:px-6 pt-2 border-t border-t-gray-200 bg-white">
      <button id="create-transaction-cancel-button" type="button" (click)="onClose()"
        class="h-8 sm:h-6 md:h-7 lg:h-8 xl:h-8 2xl:h-10 w-14 sm:w-16 md:w-20 lg:w-20 xl:w-22 2xl:w-22 rounded-lg bg-gray-100 hover:bg-gray-200 text-xs sm:text-sm text-gray-700">
        Cancel
      </button>
      <button id="create-transaction-submit-button" type="submit" [disabled]="!isSubmitEnabled || phoneInvalid"
        [ngClass]="{'bg-black text-white hover:bg-gray-800 cursor-pointer': isSubmitEnabled && !phoneInvalid, 'bg-gray-300 text-gray-400 cursor-not-allowed opacity-60': !isSubmitEnabled || phoneInvalid}"
        class="h-8 sm:h-6 md:h-7 lg:h-8 xl:h-8 2xl:h-10 w-14 sm:w-16 md:w-20 lg:w-20 xl:w-22 2xl:w-22 rounded-lg text-xs sm:text-sm transition-colors duration-200">
        Submit
      </button>
    </div>
  </form>
</app-dialog>